import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import reducer from '../reducers';

export const buildStore = (preloadedState) => {
  const logger = createLogger({ diff: false });

  // Note: Redux Toolkit's configureStore includes redux-thunk by default
  let middleWares = [];
  if (process.env.NODE_ENV === 'development') {
    middleWares = [logger];
  }
  const store = configureStore({
    reducer,
    preloadedState,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false
    }).concat(middleWares)
  });
  if (module.hot) {
    module.hot.accept(() => {
      const nextRootReducer = require('../reducers/index').default;

      store.replaceReducer(nextRootReducer);
    });
  }
  window.store = store;
  return store;
};
